
<div class="page">
    <app-header></app-header>
    <app-sidebar appHoverEffectSidebar></app-sidebar>

    <!-- Start::app-content -->
    <div class="main-content app-content" (click)="clickOnBody()" >
        <div class="container-fluid">
            <router-outlet></router-outlet>
        </div>
    </div>
    
</div>

<div id="responsive-overlay" (click)="clearToggle()"></div>